<template>
  <v-text-field
    v-model.trim="Model.basicSearch.query[def.fn.args.find(arg => arg.name === 'BasicSearchInput').name]"
    :placeholder="def.placeholder || searchLabel"
    :readonly="open"
    hide-details
    color="P1"
    dense
    rounded
    outlined
    filled
    @keyup.enter="search"
    prepend-inner-icon="mdi-magnify"
    @input="advanceSearchBTNHandler"
    class="basicSearch"
    height="36px"
  >
    <template #append>
      <v-icon
        v-if="showAdvanceSearchBTN"
        color="P1"
        height="28px"
        size="24px"
        style="margin-top : 2px"
        @click="showAdvanced"
      >
        {{ !def.searchConfig.searchPage.folderSubject ? open ? 'mdi-close' : 'mdi-tune' : '' }}
      </v-icon>
      <v-icon
        v-if="!showAdvanceSearchBTN"
        color="P1"
        height="28px"
        size="24px"
        @click="clearInput"
      >
        {{ 'mdi-close' }}
      </v-icon>
      <v-btn
        v-if="!showAdvanceSearchBTN"
        height="28px"
        rounded
        color="P1"
        style=" color:white;"
        @click="search"
      >
        جستجو
      </v-btn>
    </template>
  </v-text-field>
</template>

<script>
import { basicSearch } from "@/apis";

export default {
  name: "AbrBasicSearch",
  props: ["def", "model", "folderSearch"],
  data: function() {
    return {
      open: false,
      Model: this.model,
      showAdvanceSearchBTN : true
    }
  },
  computed: {
    searchLabel() {
      if(!this.open)
        return ` جستجوی ${this.$t(this.def.searchConfig.searchPage)}`;
      else
        return ` جستجوی پیشرفته در ${this.$t(this.def.searchConfig.searchPage)}`
    }
  },
  created() {    
    this.def.fn.args.map(async arg => {
      const value = await this.$eval(arg.default) || "";
      this.$set(this.Model.basicSearch.query, arg.name, value);
    });
    this.$eventBus.$on(`UpdateSearchPage-${this.$store.getters.getCurrentForm.route?.name}` , async () => {
      if(this.def.searchConfig.searchPage.folderSubject) {
        this.folderSearch([this.model.folderId]);
        return;
      }
      const res = await basicSearch(this.def.searchConfig.id, this.Model.basicSearch)
        this.model.result.splice(0);
        res.forEach((item, index) => this.$set(this.model.result, index, item))        
      // this.model.result = [];
      // this.model.result = await basicSearch(this.def.searchConfig.id, this.Model.basicSearch)
    })

  },
  mounted(){
    window.setImmediate(()=>{
      this.search();
    })
  },

  methods: {
    showAdvanced() {
      this.$watch("Model.openAS", nv => this.open = nv, { deep: true })
      this.Model.basicSearch.query.BasicSearchInput = "";
      this.Model.openAS = this.open = !this.open;
    },
    async search() {
      this.Model.showGrid = true
      this.Model.loading = true
      try {
        const res = await basicSearch(this.def.searchConfig.id, this.Model.basicSearch)
        this.model.result.splice(0);
        res.forEach((item, index) => this.$set(this.model.result, index, item))
        // this.Model.result = await basicSearch(this.def.searchConfig.id, this.Model.basicSearch)
      } finally {
        this.Model.loading = false
      }      
      const def = this.$store.getters.getCurrentForm.form;         
      const RelationPath = this.foundRelationPath(def,'',this.def.id);      
      const CurrentFormModel = this.$store.getters.getCurrentForm.model;
      if(RelationPath!='')CurrentFormModel[RelationPath] = this.Model.result;
    },
    foundRelationPath(def,RelationPath,id){
      if(def.relationPath) RelationPath = def.relationPath ;
      for(const index in def){
        const item = def[index];        
        if(Array.isArray(item)){          
          item.forEach(aItem=>{
            const leftId = id.slice(0,aItem.id.length);
            if(leftId==aItem.id){              
              RelationPath = this.foundRelationPath(aItem,RelationPath,id);              
            }
          });
        }

      }
      


      return RelationPath;
    },
    advanceSearchBTNHandler(nv) {
      if(nv === '')
        this.showAdvanceSearchBTN = true;
      if(nv !== '')
        this.showAdvanceSearchBTN = false;
    },
    clearInput() {
      this.$set(this.Model.basicSearch.query, this.def.fn.args[0].name, '')
      this.showAdvanceSearchBTN = true;
      this.search(); // جستجو با مقدار خالی (نمایش همه رکوردها)
    },
  },

};
</script>
<style>
.v-text-field fieldset, .v-text-field .v-input__control {
  border-color: red;
}
v-text-field--filled > .v-input__control > .v-input__slot {
  background: transparent!important;
}
.basicSearch.v-input--dense > .v-input__control > .v-input__slot {
  padding : 2px 5px !important;
}
.basicSearch .v-input__append-inner {
  margin: 2px !important ;
}
.basicSearch .v-input__prepend-inner{
  margin: 5px !important ;
}
</style>